export default {
  header: 'Medications',
  deleteConfirmationHeading: 'Delete medication?',
};
